module.exports = "../fonts/PTS55F.woff";